function indexToAlpha(index: number): string {
    return String.fromCharCode(65 + index);
}

export {indexToAlpha};
